export const nationalities = [
  { label: "Afghanistan", key: "AF", value: "AF" },
  { label: "Åland Islands", key: "AX", value: "AX" },
  { label: "Albania", key: "AL", value: "AL" },
  { label: "Algeria", key: "DZ", value: "DZ" },
  { label: "American Samoa", key: "AS", value: "AS" },
  { label: "Andorra", key: "AD", value: "AD" },
  { label: "Angola", key: "AO", value: "AO" },
  { label: "Anguilla", key: "AI", value: "AI" },
  { label: "Antarctica", key: "AQ", value: "AQ" },
  { label: "Antigua and Barbuda", key: "AG", value: "AG" },
  { label: "Argentina", key: "AR", value: "AR" },
  { label: "Armenia", key: "AM", value: "AM" },
  { label: "Aruba", key: "AW", value: "AW" },
  { label: "Australia", key: "AU", value: "AU" },
  { label: "Austria", key: "AT", value: "AT" },
  { label: "Azerbaijan", key: "AZ", value: "AZ" },
  { label: "Bahamas", key: "BS", value: "BS" },
  { label: "Bahrain", key: "BH", value: "BH" },
  { label: "Bangladesh", key: "BD", value: "BD" },
  { label: "Barbados", key: "BB", value: "BB" },
  { label: "Belarus", key: "BY", value: "BY" },
  { label: "Belgium", key: "BE", value: "BE" },
  { label: "Belize", key: "BZ", value: "BZ" },
  { label: "Benin", key: "BJ", value: "BJ" },
  { label: "Bermuda", key: "BM", value: "BM" },
  { label: "Bhutan", key: "BT", value: "BT" },
  { label: "Bolivia, Plurinational State of", key: "BO", value: "BO" },
  { label: "Bonaire, Sint Eustatius and Saba", key: "BQ", value: "BQ" },
  { label: "Bosnia and Herzegovina", key: "BA", value: "BA" },
  { label: "Botswana", key: "BW", value: "BW" },
  { label: "Bouvet Island", key: "BV", value: "BV" },
  { label: "Brazil", key: "BR", value: "BR" },
  { label: "British Indian Ocean Territory", key: "IO", value: "IO" },
  { label: "Brunei Darussalam", key: "BN", value: "BN" },
  { label: "Bulgaria", key: "BG", value: "BG" },
  { label: "Burkina Faso", key: "BF", value: "BF" },
  { label: "Burundi", key: "BI", value: "BI" },
  { label: "Cambodia", key: "KH", value: "KH" },
  { label: "Cameroon", key: "CM", value: "CM" },
  { label: "Canada", key: "CA", value: "CA" },
  { label: "Cape Verde", key: "CV", value: "CV" },
  { label: "Cayman Islands", key: "KY", value: "KY" },
  { label: "Central African Republic", key: "CF", value: "CF" },
  { label: "Chad", key: "TD", value: "TD" },
  { label: "Chile", key: "CL", value: "CL" },
  { label: "China", key: "CN", value: "CN" },
  { label: "Christmas Island", key: "CX", value: "CX" },
  { label: "Cocos (Keeling) Islands", key: "CC", value: "CC" },
  { label: "Colombia", key: "CO", value: "CO" },
  { label: "Comoros", key: "KM", value: "KM" },
  { label: "Congo", key: "CG", value: "CG" },
  { label: "Congo, the Democratic Republic of the", key: "CD", value: "CD" },
  { label: "Cook Islands", key: "CK", value: "CK" },
  { label: "Costa Rica", key: "CR", value: "CR" },
  { label: "Côte d'Ivoire", key: "CI", value: "CI" },
  { label: "Croatia", key: "HR", value: "HR" },
  { label: "Cuba", key: "CU", value: "CU" },
  { label: "Curaçao", key: "CW", value: "CW" },
  { label: "Cyprus", key: "CY", value: "CY" },
  { label: "Czech Republic", key: "CZ", value: "CZ" },
  { label: "Denmark", key: "DK", value: "DK" },
  { label: "Djibouti", key: "DJ", value: "DJ" },
  { label: "Dominica", key: "DM", value: "DM" },
  { label: "Dominican Republic", key: "DO", value: "DO" },
  { label: "Ecuador", key: "EC", value: "EC" },
  { label: "Egypt", key: "EG", value: "EG" },
  { label: "El Salvador", key: "SV", value: "SV" },
  { label: "Equatorial Guinea", key: "GQ", value: "GQ" },
  { label: "Eritrea", key: "ER", value: "ER" },
  { label: "Estonia", key: "EE", value: "EE" },
  { label: "Ethiopia", key: "ET", value: "ET" },
  { label: "Falkland Islands (Malvinas)", key: "FK", value: "FK" },
  { label: "Faroe Islands", key: "FO", value: "FO" },
  { label: "Fiji", key: "FJ", value: "FJ" },
  { label: "Finland", key: "FI", value: "FI" },
  { label: "France", key: "FR", value: "FR" },
  { label: "French Guiana", key: "GF", value: "GF" },
  { label: "French Polynesia", key: "PF", value: "PF" },
  { label: "French Southern Territories", key: "TF", value: "TF" },
  { label: "Gabon", key: "GA", value: "GA" },
  { label: "Gambia", key: "GM", value: "GM" },
  { label: "Georgia", key: "GE", value: "GE" },
  { label: "Germany", key: "DE", value: "DE" },
  { label: "Ghana", key: "GH", value: "GH" },
  { label: "Gibraltar", key: "GI", value: "GI" },
  { label: "Greece", key: "GR", value: "GR" },
  { label: "Greenland", key: "GL", value: "GL" },
  { label: "Grenada", key: "GD", value: "GD" },
  { label: "Guadeloupe", key: "GP", value: "GP" },
  { label: "Guam", key: "GU", value: "GU" },
  { label: "Guatemala", key: "GT", value: "GT" },
  { label: "Guernsey", key: "GG", value: "GG" },
  { label: "Guinea", key: "GN", value: "GN" },
  { label: "Guinea-Bissau", key: "GW", value: "GW" },
  { label: "Guyana", key: "GY", value: "GY" },
  { label: "Haiti", key: "HT", value: "HT" },
  { label: "Heard Island and McDonald Islands", key: "HM", value: "HM" },
  { label: "Holy See (Vatican City State)", key: "VA", value: "VA" },
  { label: "Honduras", key: "HN", value: "HN" },
  { label: "Hong Kong", key: "HK", value: "HK" },
  { label: "Hungary", key: "HU", value: "HU" },
  { label: "Iceland", key: "IS", value: "IS" },
  { label: "India", key: "IN", value: "IN" },
  { label: "Indonesia", key: "ID", value: "ID" },
  { label: "Iran, Islamic Republic of", key: "IR", value: "IR" },
  { label: "Iraq", key: "IQ", value: "IQ" },
  { label: "Ireland", key: "IE", value: "IE" },
  { label: "Isle of Man", key: "IM", value: "IM" },
  { label: "Israel", key: "IL", value: "IL" },
  { label: "Italy", key: "IT", value: "IT" },
  { label: "Jamaica", key: "JM", value: "JM" },
  { label: "Japan", key: "JP", value: "JP" },
  { label: "Jersey", key: "JE", value: "JE" },
  { label: "Jordan", key: "JO", value: "JO" },
  { label: "Kazakhstan", key: "KZ", value: "KZ" },
  { label: "Kenya", key: "KE", value: "KE" },
  { label: "Kiribati", key: "KI", value: "KI" },
  { label: "Korea, Democratic People's Republic of", key: "KP", value: "KP" },
  { label: "Korea, Republic of", key: "KR", value: "KR" },
  { label: "Kuwait", key: "KW", value: "KW" },
  { label: "Kyrgyzstan", key: "KG", value: "KG" },
  { label: "Lao People's Democratic Republic", key: "LA", value: "LA" },
  { label: "Latvia", key: "LV", value: "LV" },
  { label: "Lebanon", key: "LB", value: "LB" },
  { label: "Lesotho", key: "LS", value: "LS" },
  { label: "Liberia", key: "LR", value: "LR" },
  { label: "Libya", key: "LY", value: "LY" },
  { label: "Liechtenstein", key: "LI", value: "LI" },
  { label: "Lithuania", key: "LT", value: "LT" },
  { label: "Luxembourg", key: "LU", value: "LU" },
  { label: "Macao", key: "MO", value: "MO" },
  {
    label: "Macedonia, the Former Yugoslav Republic of",
    key: "MK",
    value: "MK"
  },
  { label: "Madagascar", key: "MG", value: "MG" },
  { label: "Malawi", key: "MW", value: "MW" },
  { label: "Malaysia", key: "MY", value: "MY" },
  { label: "Maldives", key: "MV", value: "MV" },
  { label: "Mali", key: "ML", value: "ML" },
  { label: "Malta", key: "MT", value: "MT" },
  { label: "Marshall Islands", key: "MH", value: "MH" },
  { label: "Martinique", key: "MQ", value: "MQ" },
  { label: "Mauritania", key: "MR", value: "MR" },
  { label: "Mauritius", key: "MU", value: "MU" },
  { label: "Mayotte", key: "YT", value: "YT" },
  { label: "Mexico", key: "MX", value: "MX" },
  { label: "Micronesia, Federated States of", key: "FM", value: "FM" },
  { label: "Moldova, Republic of", key: "MD", value: "MD" },
  { label: "Monaco", key: "MC", value: "MC" },
  { label: "Mongolia", key: "MN", value: "MN" },
  { label: "Montenegro", key: "ME", value: "ME" },
  { label: "Montserrat", key: "MS", value: "MS" },
  { label: "Morocco", key: "MA", value: "MA" },
  { label: "Mozambique", key: "MZ", value: "MZ" },
  { label: "Myanmar", key: "MM", value: "MM" },
  { label: "Namibia", key: "NA", value: "NA" },
  { label: "Nauru", key: "NR", value: "NR" },
  { label: "Nepal", key: "NP", value: "NP" },
  { label: "Netherlands", key: "NL", value: "NL" },
  { label: "New Caledonia", key: "NC", value: "NC" },
  { label: "New Zealand", key: "NZ", value: "NZ" },
  { label: "Nicaragua", key: "NI", value: "NI" },
  { label: "Niger", key: "NE", value: "NE" },
  { label: "Nigeria", key: "NG", value: "NG" },
  { label: "Niue", key: "NU", value: "NU" },
  { label: "Norfolk Island", key: "NF", value: "NF" },
  { label: "Northern Mariana Islands", key: "MP", value: "MP" },
  { label: "Norway", key: "NO", value: "NO" },
  { label: "Oman", key: "OM", value: "OM" },
  { label: "Pakistan", key: "PK", value: "PK" },
  { label: "Palau", key: "PW", value: "PW" },
  { label: "Palestine, State of", key: "PS", value: "PS" },
  { label: "Panama", key: "PA", value: "PA" },
  { label: "Papua New Guinea", key: "PG", value: "PG" },
  { label: "Paraguay", key: "PY", value: "PY" },
  { label: "Peru", key: "PE", value: "PE" },
  { label: "Philippines", key: "PH", value: "PH" },
  { label: "Pitcairn", key: "PN", value: "PN" },
  { label: "Poland", key: "PL", value: "PL" },
  { label: "Portugal", key: "PT", value: "PT" },
  { label: "Puerto Rico", key: "PR", value: "PR" },
  { label: "Qatar", key: "QA", value: "QA" },
  { label: "Réunion", key: "RE", value: "RE" },
  { label: "Romania", key: "RO", value: "RO" },
  { label: "Russian Federation", key: "RU", value: "RU" },
  { label: "Rwanda", key: "RW", value: "RW" },
  { label: "Saint Barthélemy", key: "BL", value: "BL" },
  {
    label: "Saint Helena, Ascension and Tristan da Cunha",
    key: "SH",
    value: "SH"
  },
  { label: "Saint Kitts and Nevis", key: "KN", value: "KN" },
  { label: "Saint Lucia", key: "LC", value: "LC" },
  { label: "Saint Martin (French part)", key: "MF", value: "MF" },
  { label: "Saint Pierre and Miquelon", key: "PM", value: "PM" },
  { label: "Saint Vincent and the Grenadines", key: "VC", value: "VC" },
  { label: "Samoa", key: "WS", value: "WS" },
  { label: "San Marino", key: "SM", value: "SM" },
  { label: "Sao Tome and Principe", key: "ST", value: "ST" },
  { label: "Saudi Arabia", key: "SA", value: "SA" },
  { label: "Senegal", key: "SN", value: "SN" },
  { label: "Serbia", key: "RS", value: "RS" },
  { label: "Seychelles", key: "SC", value: "SC" },
  { label: "Sierra Leone", key: "SL", value: "SL" },
  { label: "Singapore", key: "SG", value: "SG" },
  { label: "Sint Maarten (Dutch part)", key: "SX", value: "SX" },
  { label: "Slovakia", key: "SK", value: "SK" },
  { label: "Slovenia", key: "SI", value: "SI" },
  { label: "Solomon Islands", key: "SB", value: "SB" },
  { label: "Somalia", key: "SO", value: "SO" },
  { label: "South Africa", key: "ZA", value: "ZA" },
  {
    label: "South Georgia and the South Sandwich Islands",
    key: "GS",
    value: "GS"
  },
  { label: "South Sudan", key: "SS", value: "SS" },
  { label: "Spain", key: "ES", value: "ES" },
  { label: "Sri Lanka", key: "LK", value: "LK" },
  { label: "Sudan", key: "SD", value: "SD" },
  { label: "Suriname", key: "SR", value: "SR" },
  { label: "Svalbard and Jan Mayen", key: "SJ", value: "SJ" },
  { label: "Swaziland", key: "SZ", value: "SZ" },
  { label: "Sweden", key: "SE", value: "SE" },
  { label: "Switzerland", key: "CH", value: "CH" },
  { label: "Syrian Arab Republic", key: "SY", value: "SY" },
  { label: "Taiwan, Province of China", key: "TW", value: "TW" },
  { label: "Tajikistan", key: "TJ", value: "TJ" },
  { label: "Tanzania, United Republic of", key: "TZ", value: "TZ" },
  { label: "Thailand", key: "TH", value: "TH" },
  { label: "Timor-Leste", key: "TL", value: "TL" },
  { label: "Togo", key: "TG", value: "TG" },
  { label: "Tokelau", key: "TK", value: "TK" },
  { label: "Tonga", key: "TO", value: "TO" },
  { label: "Trinidad and Tobago", key: "TT", value: "TT" },
  { label: "Tunisia", key: "TN", value: "TN" },
  { label: "Turkey", key: "TR", value: "TR" },
  { label: "Turkmenistan", key: "TM", value: "TM" },
  { label: "Turks and Caicos Islands", key: "TC", value: "TC" },
  { label: "Tuvalu", key: "TV", value: "TV" },
  { label: "Uganda", key: "UG", value: "UG" },
  { label: "Ukraine", key: "UA", value: "UA" },
  { label: "United Arab Emirates", key: "AE", value: "AE" },
  { label: "United Kingdom", key: "GB", value: "GB" },
  { label: "United States", key: "US", value: "US" },
  { label: "United States Minor Outlying Islands", key: "UM", value: "UM" },
  { label: "Uruguay", key: "UY", value: "UY" },
  { label: "Uzbekistan", key: "UZ", value: "UZ" },
  { label: "Vanuatu", key: "VU", value: "VU" },
  { label: "Venezuela, Bolivarian Republic of", key: "VE", value: "VE" },
  { label: "Viet Nam", key: "VN", value: "VN" },
  { label: "Virgin Islands, British", key: "VG", value: "VG" },
  { label: "Virgin Islands, U.S.", key: "VI", value: "VI" },
  { label: "Wallis and Futuna", key: "WF", value: "WF" },
  { label: "Western Sahara", key: "EH", value: "EH" },
  { label: "Yemen", key: "YE", value: "YE" },
  { label: "Zambia", key: "ZM", value: "ZM" },
  { label: "Zimbabwe", key: "ZW", value: "ZW" }
];
